import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-shop-discounts-page',
  templateUrl: './shop-discounts-page.component.html',
  styleUrls: ['./shop-discounts-page.component.css']
})
export class ShopDiscountsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
